'use client';

import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useEffect } from 'react';
import { textDirection } from '@/i18n/routing';

export default function HtmlWrapper({ children }: { children: React.ReactNode }) {
  const features = useSelector((state: RootState) => state.features);
  const language = features?.language ?? 'en';
  const theme = features?.theme ?? 'light';

  useEffect(() => {
    // Update <html> attributes when Redux changes
    document.documentElement.setAttribute('dir', textDirection(language));
    document.documentElement.setAttribute('lang', language);

    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [language, theme]);

  return <>{children}</>;
}
